import { Stack, Text } from '@pairy/pds-react';
import { useAtomValue } from 'jotai';

import { IndividualLink } from '@/hooks/queries/file/useFileIndividualList';
import { getShortShareLink, getFileShareLink } from '@/utils/shareLink';
import { userInfoAtom } from '@/state/user/atom';
import useDeleteIndividualLink from '@/hooks/mutations/file/useDeleteIndividualLink';
import { useShortShareTokens } from '@/hooks/queries/share/useShortShareToken';

import OneToOneLinkItem from './OneToOneLinkItem';
import * as Styled from './index.styles';

interface Props {
  fileId: number;
  individualLinkList: IndividualLink[];
  refetchIndividualLinkList: () => void;
}

const OneToOneLinkList = ({
  fileId,
  individualLinkList,
  refetchIndividualLinkList,
}: Props) => {
  const userInfo = useAtomValue(userInfoAtom);

  /* 목록은 URL을 텍스트로 보여주므로 수신자 수만큼 토큰이 미리 있어야 한다.
     발급 API는 멱등이고 응답은 캐시되므로 목록을 다시 열어도 재요청하지 않는다. */
  const tokenQueries = useShortShareTokens(
    individualLinkList.map(({ hashForShare }) => ({
      targetType: 'BULK_FILE_INDIVIDUAL' as const,
      hash: hashForShare,
    })),
  );

  const { mutate: deleteLink } = useDeleteIndividualLink({
    onSuccess: () => {
      refetchIndividualLinkList();
    },
  });

  return (
    <Stack gap={16} direction="column">
      <Text variant="md-semibold" color="black">
        내가 생성한 1:1 공유용 링크 목록
      </Text>
      <Styled.Container>
        <Stack gap={8} direction="column">
          {individualLinkList.map(({ email, hash, hashForShare }, index) => (
            <OneToOneLinkItem
              key={hash}
              email={email}
              link={
                tokenQueries[index]?.data
                  ? getShortShareLink({
                      token: tokenQueries[index].data as string,
                      domain: userInfo?.domain,
                    })
                  : getFileShareLink({
                      hashId: hashForShare,
                      isBulk: true,
                      domain: userInfo?.domain,
                    })
              }
              handleLinkDelete={() => {
                deleteLink({ fileId, hash });
              }}
            />
          ))}
        </Stack>
      </Styled.Container>
    </Stack>
  );
};

export default OneToOneLinkList;
